export default __webpack_public_path__ + "building-icon-white.svg";